import { IErrorsStore } from '../../../../store/errors/store';
import { TPushNotificationAction } from '../../../../store/notification/Actions/push';

// TODO: Remove this file: a better solution is implemented as an action in the notification's store
export const sendErrorPushNotification = (
  pushNotification: TPushNotificationAction,
  errors: IErrorsStore
) => {
  const model = Object.keys(errors)[0];
  const message = errors[model] ? errors[model].msg : '';

  pushNotification({
    status: 'unread',
    text: message || '',
    type: 'error'
  });
};
